import {
  ATLButton,
  ATLSpacing,
  ATLTextHead,
  KeyboardTypeEnum,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import React from 'react'
import { FormProvider, useForm as useFormV2 } from 'react-hook-form'
import { Text } from 'react-native'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { CustomHeader } from '../../components/CustomHeader'
import { ATLTextInputDocumentMaskField } from '../../components/form/ATLTextInputCPFMaskField'
import { Loading } from '../../components/loading/Loading'
import { showErrorSnackbar, SnackbarDuration } from '../../components/snackbar/Snackbar'
import { CPF_CONSTRAINT } from '../../constants/formsConstraints'
import { CPF_LENGTH } from '../../constants/lengths'
import { platformConfig } from '../../constants/platform'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { setGlobal } from '../../global/useGlobal'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { BaseNavigationProps } from '../../navigation/_root'
import { recoverPassword } from '../../services/auth/recoverPassword'
import { buildValidatorFromConstraintsV2 } from '../../utils/buildValidatorFromConstraints'
import { getOnlyNumbers } from '../../utils/formatters'
import { usePromise } from '../../utils/hooks/usePromise'

const RedefinePasswordContainer = styled.SafeAreaView`
  background-color: ${atlTheme.ColorSurface};
  height: 100%;
`
const ButtonContainer = styled.View`
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: ${atlTheme.SpacingIntersection}px;
`
const formName = 'ForgotMyPassword'

export const formFields = {
  CPF: 'cpf',
}
const constraints = {
  [formFields.CPF]: CPF_CONSTRAINT,
}

export const PasswordRecoveryFirstScreen: NavigationStackScreenComponent<BaseNavigationProps> = () => {
  const formMethods = useFormV2({ resolver: buildValidatorFromConstraintsV2(constraints) })

  const onRequestError = (err: Error) => {
    console.log('err', err, err.message)
    if (err.message.includes("Couldn't find user")) {
      showErrorSnackbar(formatMessage(messages.forgotPassword_userNotFound), SnackbarDuration.LONG)
    } else {
      showErrorSnackbar(formatMessage(messages.forgotPassword_tryAgain), SnackbarDuration.LONG)
    }
  }
  const onRequestSuccess = () => {
    Coordinator.goToSecondPasswordRecoveryScreen()
  }

  const { loading: isRecoveringPassword, request: doRecoverPassword } = usePromise(recoverPassword, [], {
    onSuccess: onRequestSuccess,
    onError: onRequestError,
  })

  const onSuccess = async (val: any) => {
    const cpf = getOnlyNumbers(val.cpf)

    await setGlobal({
      currentCpfForPasswordRecovery: cpf,
    })

    doRecoverPassword({
      cpf,
    })
  }
  const onError = () => {
    console.log('CPF Validation error')
  }
  const onPressContinueButton = () => {
    formMethods.handleSubmit(onSuccess, onError)()
    // submit(onSuccess, onError)
  }

  return (
    <FormProvider {...formMethods}>
      <ATLSpacing type={SpacingSizesEnum.marginal} />
      <RedefinePasswordContainer>
        <ATLSpacing type={SpacingSizesEnum.marginal} />
        <ATLTextHead
          textAlignment={TextAlignmentEnum.left}
          labelBaseProps={{
            fontSize: atlTheme.FontSizeHighlight,
          }}
        >
          {formatMessage(messages.forgotPassword_main)}
        </ATLTextHead>
        <Text
          style={{
            marginHorizontal: atlTheme.SpacingMarginal,
            fontFamily: atlTheme.FontFamilySystem,
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: atlTheme.FontSizeBody,
            lineHeight: atlTheme.LineHeightBase,
          }}
        >
          {formatMessage(messages.youMustBeACustomer)}
          <Text style={{ color: atlTheme.ColorBrand1Default }}>{` ${formatMessage(messages.brio_inc)}`}</Text>.
        </Text>
        <ATLSpacing type={SpacingSizesEnum.marginal} />
        <ATLTextHead textAlignment={TextAlignmentEnum.left}>
          {formatMessage(messages.forgotPassword_pleaseProvideCpf)}
        </ATLTextHead>
        <ATLSpacing type={SpacingSizesEnum.distribute} />
        <ATLTextInputDocumentMaskField
          name={formFields.CPF}
          title={formatMessage(messages.forgotPassword_cpfLabel)}
          helpText={formatMessage(messages.forgotPassword_helpText)}
          horizontalMargin={atlTheme.SpacingMarginal}
          textInputBaseProps={{
            focusColor: atlTheme.ColorMediumContrast,
          }}
          keyboardType={platformConfig.isWeb() ? undefined : KeyboardTypeEnum.numeric}
          maxLength={CPF_LENGTH}
          formVersion={'2'}
          hideClearButton
        />
        <ATLSpacing type={SpacingSizesEnum.distribute} />
        <ButtonContainer>
          {isRecoveringPassword ? (
            <Loading />
          ) : (
            <ATLButton
              title={formatMessage(messages.forgotPassword_actionButton)}
              onPress={onPressContinueButton}
              buttonBaseProps={{
                borderRadius: atlTheme.BorderRadius100,
              }}
            />
          )}
        </ButtonContainer>
      </RedefinePasswordContainer>
    </FormProvider>
  )
}
PasswordRecoveryFirstScreen.navigationOptions = CustomHeader(
  formatMessage(messages.forgotPassword_headerTitle),
  true,
  () => Coordinator.goBack()
)
